import React from 'react'

const ConsultingTeam = ({ navigate,isMarginNone=false }) => {
    return (
        <a
            target="_blank"
            href={navigate}
            className={"button1 button btn-primary" + (isMarginNone ? ' m-0' : '')}
        >
            <div className='d-flex gap-8'>
            <img alt=""  src="../assets/support.svg" />
            <span>Support</span>

            </div>

        </a>
    )
}

export default ConsultingTeam